import { MyHelpdeskSearch } from './myHelpdeskSearch';

require('./myHelpdeskSearch.scss');

export const myHelpdeskSearchComponent = {
  template: require('./myHelpdeskSearch.html'),
  controllerAs: 'ctrl',
  controller: MyHelpdeskSearch,
};
